export const LEAD_STATUS_CODES = [
  {
    id: 0,
    name: 'new'
  },
  {
    id: 100,
    name: 'ongoing'
  },
  {
    id: 200,
    name: 'signed'
  },
  {
    id: 400,
    name: 'cold'
  }
]
